export default {
    carregando: false,
    items: [],
    itemsAtivos: [],
    tipoAgings: [],
    tipoTarefas: [],
    selecionado: {},
    dadosDetalhados: [],
    opcoesTratativas: [],
    podeInativar: false,
    tabIndex: 0,
}
